import { render, staticRenderFns } from "./menu_surfaces.vue?vue&type=template&id=69c627c2"
import script from "./menu_surfaces.js?vue&type=script&lang=js&external"
export * from "./menu_surfaces.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports